/** Shared coin/token image upload limit (logo + banner). */
export const MAX_TOKEN_IMAGE_BYTES = 5 * 1024 * 1024;
export const MAX_TOKEN_IMAGE_LABEL = "5 MB";

export const IMAGE_TOO_LARGE_MESSAGE = `Image too large (max ${MAX_TOKEN_IMAGE_LABEL}). Choose a smaller file and try again.`;

export function isImageFileTooLarge(file) {
  return Boolean(file && typeof file.size === "number" && file.size > MAX_TOKEN_IMAGE_BYTES);
}

/** Approximate decoded byte length of a `data:…;base64,…` URL. */
export function dataUrlDecodedByteLength(dataUrl) {
  if (typeof dataUrl !== "string") return 0;
  const comma = dataUrl.indexOf(",");
  if (comma < 0) return 0;
  const b64 = dataUrl.slice(comma + 1).replace(/\s/g, "");
  if (!b64) return 0;
  const padding = b64.endsWith("==") ? 2 : b64.endsWith("=") ? 1 : 0;
  return Math.max(0, Math.floor((b64.length * 3) / 4) - padding);
}

export function isDataUrlTooLarge(dataUrl) {
  return dataUrlDecodedByteLength(dataUrl) > MAX_TOKEN_IMAGE_BYTES;
}
